import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiZod } from '@/shared/api'
import { type SearchHit, SearchHitSchema, type SearchKind } from '../model/schema'

export const searchKeys = {
  all: ['search'] as const,
  query: (q: string, kind?: SearchKind, tag?: string) =>
    [...searchKeys.all, q, kind ?? '', tag ?? ''] as const,
}

export interface SearchParams {
  kind?: SearchKind | undefined
  tag?: string | undefined
  limit?: number | undefined
}

// Универсальный поиск: встречи, расшифровки, компании, проекты и теги одной
// выдачей. Пустой запрос не отправляем — бэк отвечает 400 (полный скан дорог).
export function searchQueryOptions(q: string, params: SearchParams = {}) {
  const trimmed = q.trim()
  return queryOptions({
    queryKey: searchKeys.query(trimmed, params.kind, params.tag),
    queryFn: async (): Promise<SearchHit[]> => {
      const query: Record<string, string> = { q: trimmed }
      if (params.kind) query.kind = params.kind
      if (params.tag) query.tag = params.tag
      if (params.limit) query.limit = String(params.limit)
      const body = await apiGet('/search', apiZod.zSearchResponse, query)
      return (body.data ?? []).map((dto) =>
        SearchHitSchema.parse({
          kind: dto.kind,
          entityId: dto.entity_id,
          label: dto.label,
          snippet: dto.snippet,
          matchedIn: dto.matched_in,
          score: dto.score,
          url: dto.url,
          meetingId: dto.meeting_id,
        }),
      )
    },
    enabled: trimmed.length > 0,
    placeholderData: (prev) => prev,
    staleTime: 30_000,
  })
}
